// extracted by mini-css-extract-plugin
export default {"root":"MTCbr","buyCoinsView":"wHQ7p","payments":"hN4hH","mobileGridContainer":"kJkVA","spinner":"AIpuh","confetti":"R94h4"};